import React, { useEffect, useMemo, useState } from 'react';

const UsersPage = ({ users, loadUsers, updateApproval }) => {
  const [query, setQuery] = useState('');
  const [approved, setApproved] = useState('all');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    setPage(1);
  }, [query, approved, pageSize]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    return (users || []).filter((u) => {
      if (approved === 'approved' && !u.is_approved) return false;
      if (approved === 'pending' && u.is_approved) return false;
      if (!q) return true;
      const hay = [
        u.full_name,
        u.email,
        u.phone,
      ].filter(Boolean).join(' ').toLowerCase();
      return hay.includes(q);
    });
  }, [users, query, approved]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const paged = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div className="card">
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <h3>User Approval</h3>
        <button className="secondary" onClick={loadUsers}>Refresh</button>
      </div>
      <div className="filters">
        <div className="filter-row">
          <div>
            <label>Search Email / Phone</label>
            <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search users" />
          </div>
          <div>
            <label>Approval</label>
            <select value={approved} onChange={(e) => setApproved(e.target.value)}>
              <option value="all">All</option>
              <option value="approved">Approved</option>
              <option value="pending">Pending</option>
            </select>
          </div>
          <div>
            <label>Page Size</label>
            <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
            </select>
          </div>
        </div>
        <div className="filter-actions">
          <div className="muted">Showing {paged.length} of {filtered.length}</div>
          <div className="pager">
            <button className="secondary" disabled={currentPage <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>Prev</button>
            <span className="pager-info">Page {currentPage} of {totalPages}</span>
            <button className="secondary" disabled={currentPage >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>Next</button>
          </div>
        </div>
      </div>
      <div className="list">
        {paged.map((u) => (
          <div key={u._id} className="list-item">
            <div className="row">
              <strong>{u.full_name || 'User'}</strong>
              <span className="muted">{u.email || ''}</span>
              <span className="muted">{u.phone || ''}</span>
            </div>
            <div className="row">
              <span className="muted">
                Status: {u.is_approved ? 'Approved' : 'Pending'}
              </span>
              {u.is_approved ? (
                <span className="status-badge">Approved</span>
              ) : (
                <span className="status-badge" style={{ color: '#b45309', background: '#fef3c7' }}>
                  Pending
                </span>
              )}
              <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
                <button
                  className="secondary"
                  onClick={async () => {
                    await updateApproval(u._id, true);
                    await loadUsers();
                  }}
                >
                  Approve
                </button>
                <button
                  className="secondary"
                  onClick={async () => {
                    await updateApproval(u._id, false);
                    await loadUsers();
                  }}
                >
                  Mark Pending
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UsersPage;
